
export interface NizzaPlayerProps {
    src:string
}

export default function NizzaPlayer({src}:NizzaPlayerProps) {
    return (
        <>
            <div id='nz-player' />

            <script
                id='nz-player-script'
                type='module'
                src={src}
            />
        </>
    )
}
